import { Region } from '@/services/auth/types';
import { sentryCaptureException } from '@/utils/sentry';
import { getAppVersion } from '@/utils/version';
import { isEmptyString } from '@/utils/string';
import axios from 'axios';
import Cookies from 'universal-cookie';

/**
 * @deprecated
 */
export const servicesApi = axios.create({
  baseURL: '/v1',
  withCredentials: true,
});

export function setServicesApiRegion(region: Region) {
  if (__CIO_ENV__ !== 'production' && __CIO_ENV__ !== 'standalone') {
    return;
  }

  let regionUrlMap = {
    [Region.US]: '',
    [Region.EU]: '',
  };

  if (__CIO_ENV__ === 'production') {
    regionUrlMap = {
      [Region.US]: 'https://us.fly.customer.io',
      [Region.EU]: 'https://eu.fly.customer.io',
    };
  } else if (__CIO_ENV__ === 'standalone') {
    regionUrlMap = {
      [Region.US]: 'https://us.fly-standalone.customer.io',
      [Region.EU]: 'https://us.fly-standalone.customer.io',
    };
  }

  servicesApi.defaults.baseURL = `${regionUrlMap[region]}/v1`;
}

// Default to US for auth and calls made before an account is known
setServicesApiRegion(Region.US);

for (const api of [servicesApi]) {
  api.interceptors.request.use(async (config) => {
    const cookies = new Cookies();
    const accessToken = cookies.get('_access');

    if (!isEmptyString(accessToken)) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    config.headers['x-ui-version'] = getAppVersion();

    return config;
  });
}

export function notifyOnError(error: unknown) {
  //TODO: show notification
  sentryCaptureException(error);
}

const workspaceIdRegex = /\/workspaces\/(\d*)(\/?|\/.*)$/;

export function getWorkspaceId(url: string) {
  const path = new URL(url).pathname;
  const result = path.match(workspaceIdRegex);
  if (result != null && result.length > 2) {
    return result[1];
  }
  return '';
}
